import React from 'react';
import {
  Breadcrumbs,
  Button,
  CardHeader,
  Container,
  Flex,
  Spinner,
  VisuallyHidden,
} from '@/components/ui';
import {
  IconArrowLeft,
  IconChevronRight,
  IconRefresh,
} from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/config/routes.ts';

interface ImportProgressLayoutProps {
  mappingId: string;
  onRefresh: () => void;
  breadcrumbItems: Array<{
    label: string;
    href: string;
    startIcon?: React.ReactNode;
  }>;
  children: React.ReactNode;
  status?: React.ReactNode;
  dates?: React.ReactNode;
  isRefreshing?: boolean;
}

export const ImportProgressLayout: React.FC<ImportProgressLayoutProps> = ({
  mappingId,
  onRefresh,
  breadcrumbItems,
  children,
  status,
  dates = undefined,
  isRefreshing = false,
}) => {
  return (
    <Container pt="4" pb="4" size="expand">
      <VisuallyHidden>
        <Breadcrumbs separator={<IconChevronRight />} items={breadcrumbItems} />
      </VisuallyHidden>
      <Flex
        py="2"
        mb="2"
        direction="row"
        align="end"
        gap="2"
        wrap="wrap"
        style={{
          borderBottom: '1px solid var(--divider)',
        }}
      >
        <Flex direction="column" gap="2" mr="auto">
          <Button
            variant="ghost"
            mr="2"
            size="small"
            as={Link}
            to={ROUTES.studyDataImporter}
            startIcon={<IconArrowLeft />}
          >
            Back to Data Import
          </Button>
          <CardHeader size="small" cardTitle={`Import ID: ${mappingId}`} />
          {dates}
        </Flex>

        <Flex ml="2" height="32px" align="center">
          {status}
        </Flex>

        <Button
          variant="surface"
          size="small"
          startIcon={isRefreshing ? <Spinner size="1" /> : <IconRefresh />}
          onClick={onRefresh}
          disabled={isRefreshing}
        >
          Refresh
        </Button>
      </Flex>

      {children}
    </Container>
  );
};
